import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppState } from '@app-core/store/app.reducers';
import { UserInformation } from '@app-models/user.model';
import { Store } from '@ngrx/store';
import { WebCamProfileDialogComponent } from '@shared/components/web-cam-profile-dialog/web-cam-profile-dialog.component';
import { convertBase64ToFormData } from '@shared/methods/methods';
import { Observable, of, Subscription } from 'rxjs';
import _get from 'lodash/get';
import { ProfileService } from '@app-services/profile/profile.service';
import * as actions from '@app-core/store/actions/index';

@Component({
  selector: 'app-image-profile',
  templateUrl: './image-profile.component.html',
  styleUrls: ['./image-profile.component.scss'],
})
export class ImageProfileComponent implements OnInit, OnDestroy {
  loading = false;
  fullName$: Observable<string> = of('');
  @Input() isSummary = false;
  @Input() showEditButton = false;
  public webcamImage$: Observable<string> = of('');
  private subscriptions = new Subscription();
  public user: UserInformation;
  userStorage: any;
  profileId: any;

  constructor(
    private store: Store<AppState>,
    public dialog: MatDialog,
    public breakpointObserver: BreakpointObserver,
    private profile: ProfileService
  ) {
    this.userStorage = JSON.parse(localStorage.getItem('userData'));
    this.profileId = this.userStorage.profile;
  }

  ngOnInit(): void {
    this.getUserInformation();
  }

  private getUserInformation() {
    this.subscriptions.add(
      this.store.select('profile').subscribe(({ user }) => (this.user = user))
    );

    this.profile.getUserInformation(this.profileId).subscribe((data: any) => {
      this.user = data;
    });
  }

  /**
   * Used for open the modal where the user can take a selfie for use as a profile picture.
   */
  public openModal(): void {
    let resultObserver: any;
    this.breakpointObserver
      .observe([
        Breakpoints.XSmall,
        Breakpoints.Small,
        Breakpoints.Medium,
        Breakpoints.Large,
      ])
      .subscribe((result) => {
        resultObserver = result;
      });
    const dialogRef = this.dialog.open(WebCamProfileDialogComponent, {
      width: resultObserver.breakpoints[Breakpoints.Large] ? '35%' : '100%',
      data: '',
      panelClass: 'custom-class',
    });
    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.loading = true;
        const imageAsDataUrl = _get(response, 'imageAsDataUrl', '');
        this.webcamImage$ = of(imageAsDataUrl);
        const file = convertBase64ToFormData(imageAsDataUrl);
        const formData: any = new FormData();
        formData.append('PP_photo', file, 'profile.jpg');
        this.saveProfileInfo(this.profileId, formData);
      }
    });
  }

  public saveProfileInfo(userId: number, formData: FormData) {
    this.profile.updateAvatar(userId, formData).subscribe(({ photo }) => {
      this.loading = false;
      this.store.dispatch(
        actions.setProfile({
          user: {
            ...this.user,
            detailperson: {
              ...this.user.detailperson,
              photo,
            },
          },
        })
      );
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
